import React from 'react'

function ViewBannerBreadCrumb() {
     return (
    <div className="breadcrumb-wrapper py-3 px-3">
      <div className="container">
        <h2 className="breadcrumb-title">View Banner Details</h2>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb custom-breadcrumb mb-0">
            <li className="breadcrumb-item">
              <a href="/Admin" className="breadcrumb-link">Dashboard</a>
            </li>
             <li className="breadcrumb-item">
              <a href="/banners" className="breadcrumb-link">Advertising Banners</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              View Banner Details
            </li>
          </ol>
        </nav>
      </div>
    </div>
  );
}

export default ViewBannerBreadCrumb;